import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { RBTable } from "@pallassystems/react-bootstrap-table";
import {
  Row,
  Col,
  Card,
  Button,
  Badge,
  Modal,
  Form,
  Table,
} from "react-bootstrap";
import Breadcrumb from "app/components/Breadcrumb";
import { axios } from "fake-db/mock";
import api from "app/services/api";

export default function EmployeeTable() {
  const navigate = useNavigate();
  const [showFilter, setShowFilter] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [users, setUsers] = useState([]);
  const [showEyeMenu, setShowEyeMenu] = useState(false);
  const [disabledCols, setDisabledCols] = useState({
    employee: false,
    company: false,
    contact: false,
    action: false,
  });
  const [companies, setCompanies] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [designations, setDesignations] = useState([]);
  const [shifts, setShifts] = useState([]);
  const [roles, setRoles] = useState([]);
  const [profilePhotoFile, setProfilePhotoFile] = useState(null);
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    staff_id: "",
    office_shift_id: "",
    email: "",
    contact_no: "",
    password: "",
    confirm_password: "",
    username: "",
    date_of_birth: "",
    gender: "",
    company_id: "",
    department_id: "",
    designation_id: "",
    role_users_id: "",
    joining_date: "",
    attendance_type: "",
  });

  // 🔥 ADD THESE STATES TOP ME
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(20);

  const [showCheckbox, setShowCheckbox] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);

  const columns = useMemo(
    () => [
      { accessorKey: "index", header: "No" },
      { accessorKey: "employee", header: "Employee", searchable: true },
      { accessorKey: "company", header: "Company", searchable: true },
      { accessorKey: "contact", header: "Contact", searchable: true },

      {
        accessorKey: "action",
        header: "Action",
        style: { width: "200px", textAlign: "center" },
        Cell: ({ row }) => {
          const item = row?.original || {};
          const userId = item.id;

          return (
            <div className="d-flex align-items-center gap-2">
              {/* View Button */}
              <Button
                className="btn-icon d-flex align-items-center justify-content-center"
                style={{
                  width: "32px",
                  height: "32px",
                  backgroundColor: "#663399",
                  border: "none",
                }}
                onClick={() =>
                  navigate(`/employees/${item.id}/general`, { state: item })
                }
              >
                <i className="i-Eye text-18 text-white"></i>
              </Button>

              {/* Delete Button */}
              <Button
                className="btn-icon d-flex align-items-center justify-content-center"
                style={{
                  width: "28px",
                  height: "28px",
                  backgroundColor: "#c4302b",
                  border: "none",
                  borderRadius: "4px",
                }}
                onClick={() => alert("Deleting user ID: " + userId)}
              >
                <i className="i-Close-Window text-white"></i>
              </Button>

              {/* Pdf Button */}
              <Button
                className="btn-icon d-flex align-items-center justify-content-center"
                style={{
                  width: "28px",
                  height: "28px",
                  backgroundColor: "#ffc107",
                  border: "none",
                  borderRadius: "4px",
                }}
                onClick={() => alert("PDF for user ID: " + userId)}
              >
                <i className="i-File-Horizontal-Text text-18 text-white"></i>
              </Button>

              {/* Map Button */}
              <Button
                className="btn-icon d-flex align-items-center justify-content-center"
                style={{
                  width: "28px",
                  height: "28px",
                  backgroundColor: "#007bff",
                  border: "none",
                  borderRadius: "4px",
                }}
                onClick={() => alert("Map for user ID: " + userId)}
              >
                <i className="i-Map-Marker text-white"></i>
              </Button>
            </div>
          );
        },
      },
    ],
    [],
  );

  useEffect(() => {
    api
      .get("/api/company/all")
      .then((res) => {
        setCompanies(res.data.data || []);
      })
      .catch((err) => {
        console.error("Company Fetch Error:", err);
      });
  }, []);

  useEffect(() => {
    api
      .get("/api/departments")
      .then((res) => {
        setDepartments(res.data.departments || []);
      })
      .catch((err) => {
        console.error("Department Fetch Error:", err);
      });
  }, []);

  useEffect(() => {
    if (!formData.department_id) {
      setDesignations([]);
      return;
    }
    api
      .get(`/api/designations/all?department_id=${formData.department_id}`)
      .then((res) => {
        setDesignations(res.data.data || []);
      })
      .catch((err) => {
        console.error("Designation Fetch Error:", err);
      });
  }, [formData.department_id]);

  useEffect(() => {
    api
      .get("/api/office-shifts")
      .then((res) => {
        const data = Array.isArray(res.data) ? res.data : [];
        setShifts(data.map((s) => ({ id: s.id, shift_name: s.Shift })));
      })
      .catch((err) => {
        console.error("Shift Fetch Error:", err);
      });
  }, []);

  useEffect(() => {
    api
      .get("/api/roles/all")
      .then((res) => {
        setRoles(res.data.data || []);
      })
      .catch((err) => {
        console.error("Role Fetch Error:", err);
      });
  }, []);

  useEffect(() => {
    fetchEmployees();
  }, []);

  const fetchEmployees = () => {
    api
      .get("/api/employees")
      .then((res) => {
        const data = res.data.data || [];

        console.log("Raw Employee Data:", data);

        const userList = data.map((item, ind) => ({
          employee: item.employee || [item.first_name, item.last_name].filter(Boolean).join(" ") || "N/A",
          is_active: item.is_active, // ✅ add active status to the list
          id: item.id,
          index: ind + 1,
          company: item.company || "N/A",
          department: item.department || "N/A",
          designation: item.designation || "N/A",
          role: item.role || "N/A",
          contact: item.email || item.contact_no || "N/A",
        }));

        console.log(userList)

        setUsers(userList);
      })
      .catch((err) => {
        console.error("Employee Fetch Error:", err);
        setUsers([]);
      });
  };
  // ✅ Single delete
  const handleDelete = (item) => {
    if (!window.confirm(`Delete "${item.employee}"?`)) return;

    api
      .delete(`/api/employees/${item.id}`)
      .then(() => {
        alert("Deleted Successfully ✅");
        fetchEmployees();
      })
      .catch((err) => console.error(err));
  };

  // ✅ Bulk delete
  const handleBulkDelete = () => {
    if (selectedRows.length === 0) {
      alert("Select at least 1 employee ❌");
      return;
    }

    if (!window.confirm("Delete selected employees?")) return;

    api
      .post("/api/employees/delete", { ids: selectedRows })
      .then(() => {
        alert("Bulk Deleted ✅");
        setSelectedRows([]);
        setShowCheckbox(false);
        fetchEmployees();
      })
      .catch((err) => console.error(err));
  };

  const filteredUsers = users.filter((item) =>
    (item.employee || "").toLowerCase().includes(search.toLowerCase()),
  );

  const totalRows = filteredUsers.length;
  const totalPages =
    rowsPerPage >= totalRows ? 1 : Math.ceil(totalRows / rowsPerPage);

  const startIndex = (currentPage - 1) * rowsPerPage;
  const paginatedUsers = filteredUsers.slice(
    startIndex,
    startIndex + rowsPerPage,
  );

  const handleToggleStatus = async (item) => {
    try {
      const newStatus = Number(item.is_active) === 1 ? 0 : 1;

      await api.put(`/api/employees/${item.id}/status`, {
        is_active: newStatus,
      });

      // 🔥 instant UI update
      setUsers((prev) =>
        prev.map((u) =>
          u.id === item.id ? { ...u, is_active: newStatus } : u,
        ),
      );
    } catch (err) {
      console.error(err);
      alert("Status update failed ❌");
    }
  };

  return (
    <section>
      <Breadcrumb
        routeSegments={[
          { name: "Dashboard", path: "/" },
          { name: "Employee", path: "/employees/EmployeesList" },
          { name: "Employee List" },
        ]}
      />

      <div className="mb-3">
        <Row>
          <Col lg={12}>
            <Card body>
              {/* Top Button Row */}
              <div className="d-flex justify-content-between align-items-center flex-wrap">
                {/* Left Buttons */}
                <div className="d-flex flex-wrap gap-2">
                  <Button
                    className="btn-icon d-flex align-items-center text-white border-0 shadow-none"
                    style={{ backgroundColor: "#663399" }}
                    onClick={() => setShowModal(true)}
                  >
                    <span className="ul-btn__icon">
                      <i className="i-Business-Mens text-18"></i>
                    </span>
                    <span className="ul-btn__text ml-2">Add Employee</span>
                  </Button>

                  <Button
                    className="btn-icon d-flex align-items-center text-white border-0 shadow-none"
                    style={{ backgroundColor: "#663399" }}
                    onClick={() => navigate("/employees/ImportEmployees")}
                  >
                    <span className="ul-btn__icon">
                      <i className="i-Upload text-18"></i>
                    </span>
                    <span className="ul-btn__text ml-2">Import Employee</span>
                  </Button>

                  {/* <Button
                    style={{ backgroundColor: "#c4302b" }}
                    onClick={() => {
                      if (showCheckbox && selectedRows.length > 0) {
                        handleBulkDelete();
                      } else {
                        setShowCheckbox(true);
                      }
                    }}
                  >
                    Bulk Delete
                  </Button> */}

                  {/* <Button
                    className="btn-icon d-flex align-items-center text-white border-0 shadow-none"
                    style={{ backgroundColor: "#078ea0ff" }}
                    onClick={() => setShowFilter(!showFilter)}
                  >
                    <span className="ul-btn__icon">
                      <i className="i-Filter-2 text-18"></i>
                    </span>
                    <span className="ul-btn__text ml-2">Filter</span>
                  </Button> */}
                </div>

                {/* Right Buttons */}
                <div className="d-flex gap-2 mt-2 mt-md-0">
                  <Button
                    className="btn-icon d-flex align-items-center justify-content-center"
                    style={{
                      width: 36,
                      height: 36,
                      backgroundColor: "#f44336",
                      border: "none",
                    }}
                  >
                    <i className="i-File-Horizontal-Text text-18 text-white"></i>
                  </Button>
                  <Button
                    className="btn-icon d-flex align-items-center justify-content-center"
                    style={{
                      width: 36,
                      height: 36,
                      backgroundColor: "#ffc107",
                      border: "none",
                    }}
                  >
                    <i className="i-File-CSV text-18 text-white"></i>
                  </Button>
                  <Button
                    className="btn-icon d-flex align-items-center justify-content-center"
                    style={{
                      width: 36,
                      height: 36,
                      backgroundColor: "#007bff",
                      border: "none",
                    }}
                  >
                    <i className="i-Billing text-18 text-white"></i>
                  </Button>
                  <div style={{ position: "relative" }}>
                    <Button
                      onClick={() => setShowEyeMenu(!showEyeMenu)}
                      style={{
                        width: "48px",
                        height: "36px",
                        backgroundColor: "#7e57c2",
                        border: "none",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "6px",
                        padding: 0,
                      }}
                    >
                      {/* Eye icon */}
                      <i
                        className="i-Eye text-white"
                        style={{ fontSize: "18px" }}
                      ></i>

                      {/* ▼ Triangle Arrow (exact screenshot style) */}
                      <span
                        style={{
                          width: 0,
                          height: 0,
                          borderLeft: "5px solid transparent",
                          borderRight: "5px solid transparent",
                          borderTop: "6px solid #fff",
                          marginTop: "2px",
                        }}
                      ></span>
                    </Button>

                    {/* Dropdown */}
                    {showEyeMenu && (
                      <div
                        style={{
                          position: "absolute",
                          top: "44px",
                          right: 0,
                          width: "180px",
                          backgroundColor: "#7e57c2",
                          borderRadius: "10px",
                          boxShadow: "0 10px 20px rgba(0,0,0,0.3)",
                          padding: "6px 0",
                          zIndex: 9999,
                        }}
                      >
                        {["Employee", "Company", "Contact", "action"].map(
                          (item) => (
                            <div
                              key={item}
                              style={{
                                padding: "10px 16px",
                                color: "#fff",
                                fontSize: "15px",
                                cursor: "pointer",
                              }}
                              onMouseEnter={(e) =>
                              (e.currentTarget.style.background =
                                "rgba(255,255,255,0.15)")
                              }
                              onMouseLeave={(e) =>
                              (e.currentTarget.style.background =
                                "transparent")
                              }
                            >
                              {item}
                            </div>
                          ),
                        )}
                      </div>
                    )}
                  </div>

                  {/* <Button
                    className="btn-icon d-flex align-items-center justify-content-center"
                    style={{
                      width: 36,
                      height: 36,
                      backgroundColor: "#663399",
                      border: "none",
                    }}
                  >
                    <i className="i-Eye text-18 text-white"></i>
                  </Button> */}
                </div>
              </div>

              {/* Filter Row - appears below the buttons */}
              {showFilter && (
                <Card className="mt-3 p-3">
                  <Row className="align-items-center g-2">
                    <Col md={3}>
                      <Form.Select
                        value={formData.company_id}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            company_id: e.target.value,
                            department_id: "",
                            designation_id: "",
                          })
                        }
                      >
                        <option value="">Select Company...</option>
                        {companies.map((item) => (
                          <option key={item.id} value={item.id}>
                            {item.company_name}
                          </option>
                        ))}
                      </Form.Select>
                    </Col>
                    <Col md={3}>
                      <Form.Select
                        value={formData.department_id}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            department_id: e.target.value,
                          })
                        }
                      >
                        <option value="">Select Department...</option>
                        {departments.map((item) => (
                          <option key={item.id} value={item.id}>
                            {item.department_name}
                          </option>
                        ))}
                      </Form.Select>
                    </Col>
                    <Col md={3}>
                      <Form.Select
                        value={formData.designation_id || ""}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            designation_id: e.target.value,
                          })
                        }
                      >
                        <option value="">Select Designation...</option>
                        {designations.map((item) => (
                          <option key={item.id} value={item.id}>
                            {item.designation_name}
                          </option>
                        ))}
                      </Form.Select>
                    </Col>
                    <Col md={2}>
                      <Form.Select
                        value={formData.office_shift_id || ""}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            office_shift_id: e.target.value, // ✅ correct key
                          })
                        }
                      >
                        <option value="">Select Office Shift...</option>
                        {shifts.map((item) => (
                          <option key={item.id} value={item.id}>
                            {item.shift_name}
                          </option>
                        ))}
                      </Form.Select>
                    </Col>
                    <Col md={1}>
                      <Button variant="dark" className="w-100">
                        GET
                      </Button>
                    </Col>
                  </Row>
                </Card>
              )}
            </Card>
          </Col>
        </Row>
      </div>

      <Card body>
        <div className="d-flex justify-content-between align-items-center mb-2">
          <Card.Title>Employee Table</Card.Title>

          {/* 🔍 SEARCH */}
          <input
            type="text"
            placeholder="Search"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={{ width: "250px", height: "36px" }}
          />
        </div>

        <Table bordered hover>
          <thead style={{ background: "#cfc7d9" }}>
            <tr>
              {showCheckbox && (
                <th>
                  <input
                    type="checkbox"
                    checked={
                      paginatedUsers.length > 0 &&
                      paginatedUsers.every((u) => selectedRows.includes(u.id))
                    }
                    onChange={(e) => {
                      if (e.target.checked) {
                        setSelectedRows(paginatedUsers.map((u) => u.id));
                      } else {
                        setSelectedRows([]);
                      }
                    }}
                  />
                </th>
              )}
              <th>No</th>
              <th>Employee</th>
              <th>Company</th>
              <th>Department</th> {/* NEW */}
              <th>Designation</th> {/* NEW */}
              <th>Role</th> {/* NEW */}
              <th>Contact</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {paginatedUsers.map((item, index) => (
              <tr key={item.id}>
                {showCheckbox && (
                  <td>
                    <input
                      type="checkbox"
                      checked={selectedRows.includes(item.id)}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setSelectedRows((prev) => [...prev, item.id]);
                        } else {
                          setSelectedRows((prev) =>
                            prev.filter((id) => id !== item.id),
                          );
                        }
                      }}
                    />
                  </td>
                )}
                <td>{startIndex + index + 1}</td>
                <td>{item.employee}</td>
                <td>{item.company}</td>
                <td>{item.department}</td> {/* NEW */}
                <td>{item.designation}</td> {/* NEW */}
                <td>
                  <Badge bg="primary">{item.role}</Badge> {/* 🔥 NICE UI */}
                </td>
                <td>{item.contact}</td>
                <td>
                  <div className="d-flex align-items-center gap-2">
                    <Form.Check
                      type="switch"
                      id={`status-${item.id}`}
                      checked={item.is_active === 1}
                      onChange={() => handleToggleStatus(item)}
                    />

                    <span
                      style={{
                        fontWeight: "500",
                        color: item.is_active === 1 ? "green" : "red",
                      }}
                    >
                      {item.is_active === 1 ? "Active" : "Inactive"}
                    </span>
                  </div>
                </td>
                <td>
                  <div className="d-flex gap-2">
                    {/* 👁 View */}
                    <Button
                      style={{ background: "#663399", border: "none" }}
                      onClick={() =>
                        navigate(`/employees/${item.id}/general`, {
                          state: item,
                        })
                      }
                    >
                      <i className="i-Eye text-white"></i>
                    </Button>

                    {/* ❌ Delete */}
                    {/* <Button
                      style={{ background: "#c4302b", border: "none" }}
                      onClick={() => handleDelete(item)}
                    >
                      <i className="i-Close-Window text-white"></i>
                    </Button> */}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>

        {/* 🔥 PAGINATION */}
        <div className="d-flex justify-content-end align-items-center mt-3">
          <span className="me-2">Rows per page</span>

          <Form.Select
            value={rowsPerPage}
            onChange={(e) => {
              const val =
                e.target.value === "all"
                  ? filteredUsers.length
                  : Number(e.target.value);
              setRowsPerPage(val);
              setCurrentPage(1);
            }}
            style={{ width: "90px", marginRight: "15px" }}
          >
            <option value={5}>5</option>
            <option value={20}>20</option>
            <option value="all">All</option>
          </Form.Select>

          <span className="me-3">
            {startIndex + 1}-{Math.min(startIndex + rowsPerPage, totalRows)} of{" "}
            {totalRows}
          </span>

          {/* FIRST */}
          <Button
            style={{
              backgroundColor: "#7d5bbe",
              border: "none",
              marginRight: "5px",
            }}
            disabled={currentPage === 1}
            onClick={() => setCurrentPage(1)}
          >
            ⏮
          </Button>

          {/* PREVIOUS */}
          <Button
            style={{
              backgroundColor: "#7d5bbe",
              border: "none",
              marginRight: "5px",
            }}
            disabled={currentPage === 1}
            onClick={() => setCurrentPage(currentPage - 1)}
          >
            ◀
          </Button>

          {/* NEXT */}
          <Button
            style={{
              backgroundColor: "#7d5bbe",
              border: "none",
              marginRight: "5px",
            }}
            disabled={currentPage === totalPages}
            onClick={() => setCurrentPage(currentPage + 1)}
          >
            ▶
          </Button>

          {/* LAST */}
          <Button
            style={{ backgroundColor: "#7d5bbe", border: "none" }}
            disabled={currentPage === totalPages}
            onClick={() => setCurrentPage(totalPages)}
          >
            ⏭
          </Button>
        </div>
      </Card>

      {/* Add Employee Modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Add Employee</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form>
            <Row>
              <Col md={6}>
                <Form.Group>
                  <Form.Label>First Name *</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="First Name"
                    value={formData.first_name || ""}
                    required
                    onChange={(e) =>
                      setFormData({ ...formData, first_name: e.target.value })
                    }
                  />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group>
                  <Form.Label>Last Name</Form.Label>

                  <Form.Control
                    type="text"
                    placeholder="Last Name"
                    value={formData.last_name || ""}
                    onChange={(e) =>
                      setFormData({ ...formData, last_name: e.target.value })
                    }
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row className="mt-2">
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Staff Id</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Staff Id"
                    value={formData.staff_id || ""}
                    onChange={(e) =>
                      setFormData({ ...formData, staff_id: e.target.value })
                    }
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Email *</Form.Label>
                  <Form.Control
                    type="email"
                    placeholder="example@example.com"
                    value={formData.email || ""}
                    required
                    onChange={(e) =>
                      setFormData({ ...formData, email: e.target.value })
                    }
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row className="mt-2">
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Phone</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Phone"
                    value={formData.contact_no || ""}
                    onChange={(e) =>
                      setFormData({ ...formData, contact_no: e.target.value })
                    }
                  />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group>
                  <Form.Label>Date Of Birth</Form.Label>
                  <Form.Control
                    type="date"
                    value={formData.date_of_birth || ""}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        date_of_birth: e.target.value,
                      })
                    }
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row className="mt-2">
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Gender</Form.Label>
                  <Form.Select
                    value={formData.gender || ""}
                    onChange={(e) =>
                      setFormData({ ...formData, gender: e.target.value })
                    }
                  >
                    <option>Select Gender...</option>
                    <option>Male</option>
                    <option>Female</option>
                  </Form.Select>
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group>
                  <Form.Label>Company</Form.Label>
                </Form.Group>
                <Form.Select
                  value={formData.company_id}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      company_id: e.target.value,
                      department_id: "",
                      designation_id: "",
                    })
                  }
                >
                  <option value="">Select Company...</option>
                  {companies.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.company_name}
                    </option>
                  ))}
                </Form.Select>
              </Col>
            </Row>

            <Row className="mt-2">
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Department</Form.Label>
                  <Form.Select
                    value={formData.department_id}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        department_id: e.target.value,
                        designation_id: "",
                      })
                    }
                  >
                    <option value="">Select Department...</option>
                    {departments.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.department_name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group>
                  <Form.Label>Designation</Form.Label>
                  <Form.Select
                    value={formData.designation_id || ""}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        designation_id: e.target.value,
                      })
                    }
                  >
                    <option value="">Select Designation...</option>
                    {designations.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.designation_name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>

            <Row className="mt-2">
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Office Shift</Form.Label>
                  <Form.Select
                    value={formData.office_shift_id || ""}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        office_shift_id: e.target.value, // ✅ correct key
                      })
                    }
                  >
                    <option value="">Select Office Shift...</option>
                    {shifts.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.shift_name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Username</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Username"
                    value={formData.username || ""}
                    onChange={(e) =>
                      setFormData({ ...formData, username: e.target.value })
                    }
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row className="mt-2">
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Role</Form.Label>
                  <Form.Select
                    value={formData.role_users_id || ""}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        role_users_id: e.target.value,
                      })
                    }
                  >
                    <option value="">Select Role...</option>
                    {roles.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group>
                  <Form.Label>Password *</Form.Label>
                  <Form.Control
                    type="password"
                    placeholder="Password"
                    value={formData.password || ""}
                    required
                    onChange={(e) =>
                      setFormData({ ...formData, password: e.target.value })
                    }
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row className="mt-2">
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Confirm Password *</Form.Label>
                  <Form.Control
                    type="password"
                    placeholder="Confirm Password"
                    value={formData.confirm_password || ""}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        confirm_password: e.target.value,
                      })
                    }
                  />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group>
                  {" "}
                  <Form.Label>Attendance Type</Form.Label>
                  <Form.Select
                    value={formData.attendance_type || ""}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        attendance_type: e.target.value,
                      })
                    }
                  >
                    <option value="">Select Attendance Type...</option>
                    <option value="Daily">Daily</option>
                    <option value="Hourly">Hourly</option>
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>
            <Row className="mt-2">
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Date Of Joining</Form.Label>
                  <Form.Control
                    type="date"
                    value={formData.joining_date || ""}
                    onChange={(e) =>
                      setFormData({ ...formData, joining_date: e.target.value })
                    }
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Profile Photo</Form.Label>
                  <Form.Control
                    type="file"
                    accept="image/*"
                    onChange={(e) =>
                      setProfilePhotoFile(e.target.files?.[0] || null)
                    }
                  />
                </Form.Group>
              </Col>
            </Row>
          </Form>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="primary"
            style={{
              width: "15%",
              fontSize: "20px",
              fontWeight: "40",
              textAlign: "center",
              height: "42px",
            }}
            onClick={async () => {
              if (!formData.first_name.trim() || !formData.email.trim() || !formData.password) {
                alert("First Name, Email, and Password are required.");
                return;
              }

              if (formData.password !== formData.confirm_password) {
                alert("Password and Confirm Password must match ❌");
                return;
              }

              try {
                const payload = new FormData();

                Object.entries(formData).forEach(([key, value]) => {
                  payload.append(key, value ?? "");
                });

                if (profilePhotoFile) {
                  payload.append("profile_photo", profilePhotoFile);
                }

                await api.post("/api/add/employees", payload, {
                  headers: {
                    "Content-Type": "multipart/form-data",
                  },
                });

                alert("Employee Added Successfully ✅");
                setShowModal(false);
                setProfilePhotoFile(null);
              } catch (err) {
                console.error(err);
                alert(err.response?.data?.message || "Failed to add employee.");
              }
            }}
          >
            Add
          </Button>
        </Modal.Footer>
      </Modal>
    </section>
  );
}
